import * as types from '../constants/ActionTypes'
import * as general from '../constants/General'
import * as functions from '../constants/Functions'
import {
  POSTYPE_NORMAL,
  POSTYPE_ORDERKIOSK,
  POSTYPE_CHARGINGKIOSK,
  POSTYPE_SALESKIOSK,
  POSTYPE_PRODUCTIONKIOSK,
  POSTYPE_TICKETSCANNER
} from '../constants/Types'
import cookie from 'react-cookie'
import { hashHistory } from 'react-router'
import * as generalActions from './generalActions'
import { setCulture, getLayouts, setGroup, setDefaultPage, setClosePage, getPaymentKeyAction } from '../actions/layoutActions'
import * as keyFunctionActions from './keyFunctionActions'
import * as objectActions from '../objectmanagement/actions/objectManagementActions'
import * as dataActions from './dataActions'
import * as receiptActions from './receiptActions'
import * as signalRActions from './signalRActions'
import * as ticketActions from '../ticket/actions/ticketActions'
import * as resource from '../constants/Resources'
import * as systemSetting from '../constants/SystemSettings'

function loginUnsafe(id, username) {
  return {
    type: types.LOGIN,
    id,
    username
  }
}

function login(id, username, posid) {
  return dispatch => {
    dispatch(signalRActions.Login(posid));
    cookie.save(general.COOKIE_POS_LASTUSERID, id, { path: '/' });
    cookie.save(general.COOKIE_POS_LASTPOSID, posid, { path: '/' });
    dispatch(loginUnsafe(id, username))
  }
}

function logoutUnsafe() {
  return {
    type: types.LOGOUT
  }
}

function receiveUsers(json) {
  return {
    type: types.RECEIVE_USERS,
    json
  }
}

function fetchUsers() {
  return dispatch => fetch(general.API_URL_LIST_USERS)
    .then(response => response.json())
    .then(json => dispatch(receiveUsers(json)));
}

export function getUsers() {
  return (dispatch) => dispatch(fetchUsers())
}

export function loginUser(posUser) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_LOGIN_USER, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(posUser)
    })
      .then(generalActions.checkStatusError)
      .then(generalActions.parseJSON)
      .then((data) => {
        switch (data.Code) {
          case 100: // LoginSuccessful
            dispatch(generalActions.setBlackboxReceiptId(data.BlackboxReceiptId));
            dispatch(generalActions.loadingEnd());

            dispatch(ticketActions.clearValidationResult());

            dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.FETCH_DEVICES)), false));
            dispatch(generalActions.getDevices()).then(() => {
              dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.FETCH_PAYMENT_METHODS)), false));
              dispatch(generalActions.getPaymentMethods()).then(() => {
                dispatch(generalActions.getCountries()).then(() => {
                  dispatch(generalActions.getCustomerGroups()).then(() => {
                    dispatch(generalActions.getLabels()).then(() => {
                      dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.FETCH_CONFIGURATIONS)), false));
                      dispatch(generalActions.getSystemSettingByKey(systemSetting.KIOSK_LOGOFF_BARCODE)).then(() => {
                        dispatch(generalActions.getSystemSettingByKey(systemSetting.FONT_SIZE_CUSTOMER_DISPLAY)).then(() => {
                          dispatch(generalActions.getSystemSettingByKey(systemSetting.DISABLE_PAYMENTS_WITH_INVOICE)).then(() => {
                            dispatch(generalActions.getSystemSettingByKey(systemSetting.DISABLE_VATNUMBER_VALIDATION)).then(() => {
                              dispatch(generalActions.getSystemSettingByKey(systemSetting.ENABLE_INFO_REQUIRED_FOR_INVOICE)).then(() => {
                                dispatch(generalActions.getSystemSettingByKey(systemSetting.ENABLE_CUSTOMER_INFO_REQUIRED_FOR_INVOICE)).then(() => {
                                  dispatch(generalActions.getSystemSettingByKey(systemSetting.DISCOUNTMENU_ARTICLEID)).then(() => {
                                    const defaultDiscountMenuArticleID = Number(getState().generalState.systemSettings[systemSetting.DISCOUNTMENU_ARTICLEID]);
                                    if (defaultDiscountMenuArticleID) {
                                      dispatch(generalActions.addDiscountMenuArticleIds([defaultDiscountMenuArticleID]));
                                    }
                                    dispatch(generalActions.getHasFiscalPrinter());
                                      dispatch(generalActions.getConfigurationSteps()).then(() => {
                                        dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.FETCH_ARTICLES)), false));
                                        dispatch(generalActions.getArticles()).then(() => {
                                          dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.FETCH_OBJECTS)), false));
                                          dispatch(objectActions.getObjectGroupList(posUser.PosId)).then(() => {
                                            dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.FETCH_RIGHTS)), false));
                                            dispatch(getUsers()).then(() => {
                                              dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.FETCH_PRICELISTS)), false));
                                              dispatch(generalActions.getPriceLists()).then(() => {
                                                dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.FETCH_DEFAULT_CHANGE)), false));
                                                dispatch(generalActions.getPosDefaultChangePayment(posUser.PosId)).then(() => {
                                                  dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.FETCH_CASHREGISTER_ENVIRONMENT)), false));
                                                  dispatch(getLayouts()).then(() => {

                                                    if (getState().layoutState.groups !== null
                                                      && getState().layoutState.groups.items.length > 0) {
                                                      dispatch(setGroup(getState().layoutState.groups.items[0].KeyLayoutGroupId))

                                                      if (getState().layoutState.groups.items.find(x => x.DefaultPage === true)) {
                                                        dispatch(setDefaultPage(getState().layoutState.groups.items.find(x => x.DefaultPage === true).KeyLayoutGroupId));
                                                      }
                                                      if (getState().layoutState.groups.items.find(x => x.ClosePage === true)) {
                                                        dispatch(setClosePage(getState().layoutState.groups.items.find(x => x.ClosePage === true).KeyLayoutGroupId));
                                                      }

                                                      dispatch(getPaymentKeyAction(getState().layoutState.groups.items[0].KeyLayoutId));
                                                    }

                                                    dispatch(generalActions.setSplashModal(false, 'default', false));

                                                    dispatch(login(data.SystemUserId, data.SystemUsername, posUser.PosId));
                                                    const user = dispatch(dataActions.getSystemUser(data.SystemUserId));

                                                    dispatch(setCulture(user.Culture));

                                                    if (getState().generalState.paymentMethod.all !== null
                                                      && getState().generalState.paymentMethod.all.length > 0) {
                                                      let roundAmount = false;
                                                      if (getState().generalState.paymentMethod.all.find(x => x.RoundAmount === true)) {
                                                        roundAmount = true;
                                                      }

                                                      dispatch(generalActions.setRoundAmount(roundAmount));
                                                    }

                                                    let objectOpen = false;
                                                    if (user !== null
                                                      && user.ObjectItems.length === 1) {
                                                      const objectItem = dispatch(dataActions.getObjectItem(user.ObjectItems[0]));
                                                      if (objectItem !== null) {
                                                        dispatch(keyFunctionActions.continueObjectManagementOpen(objectItem));
                                                        objectOpen = true;
                                                      }
                                                    }

                                                    const pos = dispatch(dataActions.getPos(posUser.PosId));

                                                    if (pos !== null) {
                                                      if (pos.PriceListId > 0) {
                                                        dispatch(generalActions.setPosPricelist(pos.PriceListId));
                                                        dispatch(receiptActions.setPriceList(pos.PriceListId));
                                                      }

                                                      dispatch(generalActions.setPosGraphicDisplay(pos.GraphicDisplay));
                                                      dispatch(generalActions.setPos(pos.PosId, pos.Description, pos.PosType, pos.PrintReceiptInfo, pos.DisplayMode, pos.ResetTime, pos.UseConfigurations, pos.AllowEmptyPrice, pos.OpeningTime, pos.ClosingTime, pos.UsePager, pos.HasBlackbox));
                                                      dispatch(generalActions.getUniqueId(pos.PosId));
                                                    }

                                                    if (pos !== null
                                                      && pos.ObjectManagementRequired
                                                      && !objectOpen
                                                      && pos.PosType === POSTYPE_NORMAL) {
                                                      dispatch(generalActions.setKeyFunctionExecuted(functions.ObjectManagementOpen));
                                                      dispatch(keyFunctionActions.processObjectManagementOpen());
                                                    }
                                                    else if (pos.PosType === POSTYPE_ORDERKIOSK || pos.PosType === POSTYPE_SALESKIOSK) {
                                                      hashHistory.push("/kiosk");
                                                    }
                                                    else if (pos.PosType === POSTYPE_CHARGINGKIOSK) {
                                                      hashHistory.push("/chargingkiosk");
                                                    }
                                                    else if (pos.PosType === POSTYPE_PRODUCTIONKIOSK) { //Production pos
                                                      dispatch(generalActions.setKeyFunctionExecuted(functions.ObjectManagementOpen));
                                                      hashHistory.push("/production");
                                                    }
                                                    else if (pos.PosType === POSTYPE_TICKETSCANNER) {
                                                      hashHistory.push("/ticketscanner");
                                                    }
                                                    else {
                                                      hashHistory.push('/overview');
                                                    }
                                                  });
                                                });
                                              });
                                            });
                                          });
                                        });
                                      });
                                    });
                                  });
                              });
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
            }).catch(() => { dispatch(generalActions.setSplashModal(true, dispatch(dataActions.getTranslation(resource.ERROR_FETCHING_DATA)), true)); });
            break;
          default: // 200 = WrongPassword, 300 = ToManySessions, 400 = AlreadyUsed
            dispatch(generalActions.loadingEnd());
            dispatch(generalActions.setMessageModal(true, data.Description));
            break;
        }
      }).catch(error => {
        if (error.response.status === 423) {
          dispatch(generalActions.loadingEnd());
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ERROR_LICENSE))))
        }
      });

    const pos = dispatch(dataActions.getPos(posUser.PosId));
    if (pos.PosType === POSTYPE_NORMAL) {
      // var licenses = dispatch(dataActions.getPos(posUser.PosId));
      dispatch(generalActions.getDaysTillExpired()).then((json) => {
        var daysLeft = json.daysLeft;
        if (daysLeft <= 30) {
          var string1 = dispatch(dataActions.getTranslation(resource.EXPIRE_LICENSE1));
          var string2 = dispatch(dataActions.getTranslation(resource.EXPIRE_LICENSE2));
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(string1 + " " + daysLeft + " " + string2))));
        }
      });
    }
  }
}

export function setLogOut(setLogOut) {
  return {
    type: types.SET_LOGOUT,
    setLogOut
  }
}

export function logoutUser() {
  return (dispatch, getState) => {
    dispatch(receiptActions.emptyReceipt(false));

    const posid = getState().generalState.posId;

    const posUser = {
      SystemUserId: getState().loginState.loggedin.id,
      SystemUsername: getState().loginState.loggedin.username,
      PosId: posid
    }

    return fetch(general.API_URL_LOGOUT_USER, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(posUser)
    })
      .then(generalActions.checkStatus)
      .then(generalActions.parseJSON)
      .then(dispatch(logoutUnsafe()))
      .then(dispatch(signalRActions.Logout(posid)))
      .then(hashHistory.push('/login'))
  }
}



// WEBPACK FOOTER //
// src/actions/loginActions.js